var map = {
	"./about_us_main/RolVzroslogo.jpg": "ItpX",
	"./about_us_main/UvazhenieLichnosti.jpg": "zZFf",
	"./about_us_main/VpitivUm.jpg": "KUo2",
	"./about_us_main/razvivaushSreda.jpg": "N+ID",
	"./about_us_main/svo.jpg": "LZgv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9oCO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/about_us_main.*\.jpg$
// module id = 9oCO
// module chunks = 1